import React from 'react';
import { Button, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../redux/hooks";
import ProcurementContainer from '../containers/ProcurementContainer';
import ProcurementProcessList from '../lists/ProcurementProcessList';
import {useRouter} from "../../../hooks/useRouter";

const ProcurementProcess: React.FC = () => {
  const user = useAppSelector(state => state.auth.user);
  const router = useRouter();

  return (
    <ProcurementContainer>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <Grid item xs={12}>
          <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
            Procurement Tracking System
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Card raised={true} sx={{ borderRadius: '20px', margin: 2, boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)' }}>
            <CardContent>
              <Stack direction={'row'} justifyContent="space-between" alignItems="center">
                <Typography variant='h3' gutterBottom style={{ color: '#345678' }}>Procurement Processes Initiated</Typography>
                <Button
                  onClick={() => router.push(`/procurement/create-requisition`)}
                  disabled={!user?.roles?.includes('site-agent') && !user?.roles?.includes('admin')}
                >
                  Initiate Procurement Process
                </Button>
              </Stack>
              <ProcurementProcessList />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </ProcurementContainer>
  )
}

export default ProcurementProcess;
